import {
  AuthorityType,
  FormikAccidentCircumstances,
  FormikAccidentData,
  FormikAccidentGeneralInfo,
  FormikAccidentMaterialDamages,
  FormikCompany,
  FormikContractor,
  FormikDriver,
  FormikGreenCard,
  FormikInjured,
  FormikInjuredsInfo,
  FormikVehicle,
  FormikVehicleInfo,
  FormikVehicleOwner,
  FormikWitness,
  FormikWitnessesInfo,
  VehicleOwnerType,
  VehicleType,
  YesNoAnswer,
} from "src/types";
import { formatDate } from "src/utils";

export const defaultVehicleOwnerFormikValues: FormikVehicleOwner = {
  ownerCoincidesWithContractor: YesNoAnswer.YES,
  name: "",
  surname: "",
  fiscalCodeOrVAT: "",
  phoneNumber: {
    formattedPhone: "",
  },
  email: "",
  address: "",
  placeOfBirth: "",
  dateOfBirth: "",
  subjectType: VehicleOwnerType.NATURAL,
};

export const defaultVehicleContractorFormikValues: FormikContractor = {
  name: "",
  surname: "",
  fiscalCodeOrVAT: "",
  address: "",
};

export const defaultVehicleInfoFormikValues: FormikVehicleInfo = {
  type: "",
  plate: "",
  registrationStatus: "Italia",
};

export const defaultGreenCardFormikValues: FormikGreenCard = {
  number: "",
  startDate: "",
  endDate: "",
};

export const defaultCompanyFormikValues: FormikCompany = {
  companyName: "",
  impresaDb: undefined,
  agencyName: "",
  policyNumber: "",
  greenCard: { ...defaultGreenCardFormikValues },
  materialDamageCoverage: YesNoAnswer.YES,
};

export const defaultVehicleDriverFormikValues: FormikDriver = {
  driverCoincidesWithContractor: YesNoAnswer.YES,
  surname: "",
  name: "",
  dateOfBirth: "",
  fiscalCodeOrVAT: "",
  address: "",
  phoneNumber: {
    formattedPhone: "",
  },
  email: "",
  licenseNumber: "",
  category: undefined,
  validUntil: "",
  fullName: "", //TODO: serve?
};

export const defaultVehicleDamages = {
  impactPoints: [],
  visibleDamages: "",
  notes: "",
};

export const defaultVehicleFormikValues: FormikVehicle = {
  owner: { ...defaultVehicleOwnerFormikValues },
  contractor: { ...defaultVehicleContractorFormikValues },
  vehicleInfo: { ...defaultVehicleInfoFormikValues },
  company: { ...defaultCompanyFormikValues },
  driver: { ...defaultVehicleDriverFormikValues },
  vehicleDamages: { ...defaultVehicleDamages },
};

export const defaultInjuredFormikValues: FormikInjured = {
  type: undefined,
  surname: "",
  name: "",
  phoneNumber: {
    formattedPhone: "",
  },
  email: "",
  fiscalCode: "",
  address: "",
  placeOfBirth: "",
  dateOfBirth: "",
  emergencyRoom: YesNoAnswer.NO,
  emergencyRoomName: "",
  emergencyRoomMunicipality: "",
};

export const defaultInjuredsInfo: FormikInjuredsInfo = {
  injuredQuestion: undefined,
  injuredList: [],
};

export const defaultWitnessFormikValues: FormikWitness = {
  name: "",
  surname: "",
  address: "",
  fiscalCode: "",
  email: "",
  phoneNumber: {
    formattedPhone: "",
  },
  placeOfBirth: "",
  dateOfBirth: "",
};

export const createDefaultAccidentCircumstances = (
  vehicleType: VehicleType,
): FormikAccidentCircumstances => ({
  selectedCircumstance: undefined,
  vehicleType,
});

export const defaultAccidentGeneralInfo: FormikAccidentGeneralInfo = {
  accidentDate: formatDate(new Date()),
  accidentHour: "",
  accidentLocation: "",
};

export const defaultAccidentMaterialDamages: FormikAccidentMaterialDamages = {
  otherVehiclesDamaged: undefined,
  otherVehiclesDamageDetails: "",
  otherObjectsDamaged: undefined,
  otherObjectsDamageDetails: "",
};

export const defaultWitnessesInfo: FormikWitnessesInfo = {
  authorityIntervention: YesNoAnswer.NO,
  authority: undefined,
  witnessesList: [],
};

export const defaultAccidentDataFormikValues: FormikAccidentData = {
  generalInfo: { ...defaultAccidentGeneralInfo },
  injuredsInfo: { ...defaultInjuredsInfo },
  materialDamages: { ...defaultAccidentMaterialDamages },
  witnessesInfo: { ...defaultWitnessesInfo },
  vehicleAccidentCircumstances: [
    { ...createDefaultAccidentCircumstances(VehicleType.VEHICLE_A) },
    { ...createDefaultAccidentCircumstances(VehicleType.VEHICLE_B) },
  ],
};

export const defaultDraftCAIFormikValues = {
  accidentData: { ...defaultAccidentDataFormikValues },
  vehicleA: {
    ...defaultVehicleFormikValues,
    company: { ...defaultCompanyFormikValues, companyName: "ITAS MUTUA" },
  },
  vehicleB: { ...defaultVehicleFormikValues },
};
